import React from "react";
import roundedRect from "./roundedRect";

class CameraCapture extends React.Component {
  constructor(props) {
    super(props);
    this.videoRef = React.createRef();
    this.canvasRef = React.createRef();
    this.animationFrameId = null;
    this.state = { flip: true };
    this.progress = 0;
  }

  getCollectionName() {
    return "residents";
  }

  componentDidMount() {
    this.setupWebcam();
  }

  componentWillUnmount() {
    if (this.animationFrameId !== null) {
      cancelAnimationFrame(this.animationFrameId);
    }
    this.stopTracks();
  }

  stopTracks() {
    if (this.videoRef.current && this.videoRef.current.srcObject) {
      const tracks = this.videoRef.current.srcObject.getTracks();
      tracks.forEach((track) => track.stop());
    }
  }

  async setupWebcam() {
    const options = { video: true };
    const stream = await navigator.mediaDevices.getUserMedia(options);
    const video = this.videoRef.current;
    const canvas = this.canvasRef.current;
    if (!video) return;
    video.srcObject = stream;
    video.onloadedmetadata = () => {
      video.play();
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      this.processFrames();
    };
  }

  processFrames() {
    const video = this.videoRef.current;
    let startTime = performance.now();
    const drawFrame = async (timestamp) => {
      if (video.paused || video.ended) return;
      const elapsed = timestamp - startTime;
      const deltaTime = elapsed / 1000;
      startTime = timestamp;
      await this.draw(deltaTime);
      this.animationFrameId = requestAnimationFrame(drawFrame);
    };
    this.animationFrameId = requestAnimationFrame(drawFrame);
  }

  async draw(delta) {
    const canvas = this.canvasRef.current;
    if (canvas === null) return;
    const video = this.videoRef.current;
    const context = canvas.getContext("2d");

    context.clearRect(0, 0, canvas.width, canvas.height);

    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;
    const radius = 150;

    const squareSize = radius * 2;
    const squareX = centerX - radius;
    const squareY = centerY - radius;

    if (this.state.flip) {
      context.save();
      context.scale(-1, 1);
      context.translate(-canvas.width, 0);
    }

    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    if (this.state.flip) {
      context.restore();
    }

    const faceRegion = context.getImageData(
      squareX,
      squareY,
      squareSize,
      squareSize
    );
    const faceCanvas = document.createElement("canvas");
    faceCanvas.width = squareSize;
    faceCanvas.height = squareSize;
    const faceCtx = faceCanvas.getContext("2d");
    faceCtx.putImageData(faceRegion, 0, 0);

    context.beginPath();
    const x = squareX;
    const y = squareY;
    const width = squareSize;
    const height = squareSize;
    roundedRect(context, x, y, width, height, radius);
    context.fillStyle = "#FFFFFF";
    context.rect(canvas.width, 0, -canvas.width, canvas.height);
    context.fill();

    if (this.props.hasFPS) {
      const FPS = 1 / delta;
      context.font = "10px Arial";
      context.fillStyle = "green";
      context.fillText(`FPS: ${Math.ceil(FPS)}`, 20, 20);
    }

    if (this.videoState === "CAPTURE") {
      this.videoState = "INITIAL";
      this.props.onCapture(faceCanvas);
    } else {
      this.progress = 0;
    }
  }

  handleCaptureClick = () => {
    this.videoState = "CAPTURE";
    this.progress = 0;
  };

  render() {
    return (
      <div>
        <div>
          <video className="w-100 h-100 d-none" ref={this.videoRef} />
          <canvas className="w-100 h-100" ref={this.canvasRef} />
          <div className="text-center">
            {this.props.hasCapture && (
              <button
                className="btn btn-link text-danger"
                onClick={this.handleCaptureClick}
              >
                <i className="bi bi-record-circle-fill display-6"></i>
              </button>
            )}
          </div>
        </div>
        <div className="p-3 mx-3">
          <label className="fw-bold" style={{ color: `#d18237` }}>
            Istructions:
          </label>
          <div
            className="mb-3 p-2"
            style={{
              backgroundColor: "#f8f9fa",
              color: "#333",
              borderRadius: "8px",
              fontSize: "14px",
              fontWeight: "500",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
              display: "inline-block",
            }}
          >
            <p>
              1. Use a Well-Lit Area Stand in a bright room or face natural
              light. Avoid shadows or backlighting.
            </p>
            <p>
              2. Use a Plain Background A white or light-colored wall is best.
              Avoid busy or distracting backgrounds.
            </p>
            <p>
              3. Wear Appropriate Clothing Dress neatly in appropriate attire.
              Avoid sleepwear or revealing clothes.
            </p>
            <p>
              4. Avoid Excessive Makeup Keep your appearance natural and close
              to your everyday look.
            </p>
            <p>
              5. Frame Your Face Clearly Face the camera directly. Make sure
              your entire face is visible — no sunglasses, hats, or face masks.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

const defaultProps = {
  hasFPS: false,
  onCapture: () => {},
  hasCapture: true,
};
CameraCapture.defaultProps = defaultProps;
export default CameraCapture;
